export default __webpack_public_path__ + "static/media/perugbc4.0843d66c.jpg";